export default __webpack_public_path__ + "static/3-79a092a64f85f37c308e5617aa10d3ab.jpeg";